import React from 'react'
import './styles/index.scss'
import { useSelector } from 'react-redux'
import HtmlParser from 'react-html-parser'

const AboutUsV2 = () => {
  const { languageData } = useSelector((state) => state.language)

  return (
    <div className='about-us-v2'>
      <div className='accordion' id='about-us-accordion'>
        <div className='accordion-item about-us-v2__accordion-item'>
          <h2 className='accordion-header' id='headingOne'>
            <button
              className='accordion-button show about-us-v2__accordion-button'
              type='button'
              data-toggle='collapse'
              data-target='#about-us-content'
              aria-expanded='false'
              aria-controls='about-us-content'
            >
              {languageData?.homeAbout}
            </button>
          </h2>
          <div
            id='about-us-content'
            className='accordion-collapse show'
            aria-labelledby='headingOne'
            data-bs-parent='#about-us-accordion'
          >
            <div className='accordion-body about-us-v2__body fade-scroll'>
              {HtmlParser(languageData?.homeAboutContent)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutUsV2
